<div class="header scrolled">
  <img class="logo white-logo" src="../../../assets/img/white-logo.png" />
  <img class="logo d-none dark-logo" src="../../../assets/img/logo.png" />

  <i #menu_icon class="bi bi-list d-block d-md-none pointer menu-icon"></i>

  <ul class="tabs d-none d-md-flex" #header>
    <div>
      <img
        src="../../../../assets/img/close.svg"
        class="d-block d-md-none pointer close-icon"
        #close_icon
      />
    </div>

    <li>
      <a
        class="tab-item"
        #tab_item
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        >{{ "Home" | translate }}</a
      >
    </li>

    <div class="line"></div>
    <li>
      <a routerLink="" fragment="services" class="tab-item" #tab_item>{{
        "Services" | translate
      }}</a>
    </li>

    <div class="line"></div>
    <li>
      <a
        class="tab-item"
        #tab_item
        routerLink="/articles"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        >{{ "Articles" | translate }}</a
      >
    </li>

    <div class="line"></div>
    <li>
      <a
        routerLink="/contact"
        class="tab-item"
        #tab_item
        routerLinkActive="active"
        >{{ "Contact" | translate }}</a
      >
    </li>
    <div class="line"></div>

    <li>
      <a class="tab-item" (click)="changeLang()">{{ userLang }}</a>
    </li>
    <li>
      <a *ngIf="!accessToken" routerLink="/login">
        <button class="button" #tab_item>
          {{ "Get Start" | translate }}
        </button>
      </a>
      <a *ngIf="accessToken" (click)="logout()">
        <button class="button" #tab_item>
          {{ "Logout" | translate }}
        </button>
      </a>
    </li>
  </ul>
</div>
